<template>
  <div class="flex min-w-0 flex-row gap-1">
    <IAITooltip :show="isProfileNameTruncated" side="top" :side-offset="5">
      <template #trigger>
        <span ref="profileNameRef" class="truncate text-sm font-semibold">{{ profileName }}</span>
      </template>

      <template #content>
        <span>{{ profileName }}</span>
      </template>
    </IAITooltip>

    <Tags v-show="mobile_or_desktop === 'desktop'" :tag-list="formattedTags" :show-all="false" size="small" />
  </div>
</template>

<script lang="ts" setup>
import { IAITooltip } from "@/core-ui-vue";
import Tags from "@/features/profile-shop/components/Tags.vue";
import { computed, ref } from "vue";
import { universalStorage } from "@/utils/universal-storage";

interface Props {
  profileName: string;
  tags: string[];
}

const props = defineProps<Props>();
const { mobile_or_desktop } = universalStorage.getAll();

const profileNameRef = ref<HTMLSpanElement>();

const formattedTags = computed(() => props.tags.map((tag) => ({ label: tag })));

const isProfileNameTruncated = computed(() => {
  return (profileNameRef.value?.offsetWidth || 0) < (profileNameRef.value?.scrollWidth || 0);
});
</script>
